import { render, staticRenderFns } from "./newCarriage.vue?vue&type=template&id=145723f6&scoped=true&"
import script from "./newCarriage.vue?vue&type=script&lang=js&"
export * from "./newCarriage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145723f6",
  null
  
)

export default component.exports